import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import swal from "sweetalert";

import { vacancySchema } from "./Validation/VacancyValidation";

import { StyledLabel, StyledButton } from "./styles";
import { producaov2 as api } from "../../../../../../services/apis";

const CreateSegmentForm = props => {
  const [segmentName, setSegmentName] = useState({ value: "", error: "" });
  const [segmentDescription, setSegmentDescription] = useState({
    value: "",
    error: "",
  });
  // const [type, setType] = useState({ value: "", error: "" });
  const [icon, setIcon] = useState({ value: "", error: "" });
  const [urlAmigavel, setUrlAmigavel] = useState({ value: "", error: "" });
  const [redirect, setRedirect] = useState(false);

  const validateField = async (fieldName, value) => {
    try {
      await vacancySchema.validateAt(fieldName, { [fieldName]: value });
      return "";
    } catch (error) {
      return error.message;
    }
  };

  const handleSegmentNameChange = async e => {
    const value = e.target.value;
    const error = await validateField("segmento", value);
    setSegmentName({ value, error });
  };
  const handleSegmentDescriptionChange = async e => {
    const value = e.target.value;
    const error = await validateField("segmento_description", value);
    setSegmentDescription({ value, error });
  };
  const handleTypeChange = async e => {
    const value = e.target.value;
    const error = await validateField("type", value);
    setType({ value, error });
  };
  const handleIconChange = async e => {
    const value = e.target.value;
    const error = await validateField("icon", value);
    setIcon({ value, error });
  };
  const handleUrlAmigavelChange = async e => {
    const value = e.target.value;
    const error = await validateField("url_amigavel", value);
    setUrlAmigavel({ value, error });
  };

  const submitForm = async e => {
    e.preventDefault();
    try {
      await vacancySchema.validate(
        {
          segmento: segmentName.value,
          segmento_description: segmentDescription.value,
          // type: type.value,
          icon: icon.value,
          url_amigavel: urlAmigavel.value,
        },
        { abortEarly: false }
      );

      await api
        .post("faq-categorias", {
          segmento: segmentName.value,
          text_segmento: segmentDescription.value,
          // tipo: +type.value,
          icon: icon.value,
          url_amigavel: urlAmigavel.value,
        })
        .then(async () => {
          const logs = {
            local: "admin/faq/criar-segmento",
            texto: `Criou um novo segmento para FAQ (${segmentName.value})`,
          };
          await api.post("system_logs", {
            acao: JSON.stringify(logs),
          });
          swal("Segmento criado com sucesso", "", "success").then(_ =>
            setRedirect(true)
          );
        });

      setSegmentName({ value: "", error: "" });
      setSegmentDescription({ value: "", error: "" });
      setIcon({ value: "", error: "" });
      setUrlAmigavel({ value: "", error: "" });
    } catch (error) {
      if (error) {
        error.inner.forEach(e => {
          swal(
            "Preencha todos os campos ",
            "Se o erro persistir, contacte o TI",
            "error"
          );

          if (e.path === "name") {
            setName(prev => ({ ...prev, error: e.message }));
          } else if (e.path === "vacancy_link") {
            setVacancyLink(prev => ({ ...prev, error: e.message }));
          }
        });
      }
      const logs = {
        local: "admin/faq/criar-segmento",
        texto: `Tentou criar um novo segmento - Erro: ${error}`,
      };
      await api.post("system_logs", {
        acao: JSON.stringify(logs),
      });
      swal(
        "Erro ao criar um novo segmento módulo",
        "Favor contactar TI",
        "error"
      ).then(_ => setRedirect(true));
    }
  };

  return (
    <>
      {redirect && <Redirect to="/admin/faq" />}
      <Form>
        <Form.Field>
          <StyledLabel>Nome do segmento para o FAQ</StyledLabel>
          <Form.Input
            name="name"
            placeholder="Ex: Voitto PRO"
            value={segmentName.value}
            onChange={handleSegmentNameChange}
          />
        </Form.Field>
        {segmentName.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {segmentName.error}
          </p>
        )}
        <Form.Field>
          <StyledLabel>Descrição do segmento</StyledLabel>
          <Form.Input
            name="name"
            placeholder="Ex: Dúvidas sobre a assinatura e cancelamento do Voitto PRO"
            value={segmentDescription.value}
            onChange={handleSegmentDescriptionChange}
          />
        </Form.Field>
        {segmentDescription.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {segmentDescription.error}
          </p>
        )}
        {/* <Form.Field>
          <StyledLabel>Tipo</StyledLabel>
          <Form.Input
            type="number"
            placeholder="Ex: 12"
            value={type.value}
            onChange={handleTypeChange}
          />
        </Form.Field>
        {type.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {type.error}
          </p>
        )} */}
        <Form.Field>
          <StyledLabel>Icon</StyledLabel>
          <Form.Input
            name="name"
            placeholder="Ex: https://files.voitto.com.br/faq/Icon6.svg (Pedir pra UX caso não tenha, )"
            value={icon.value}
            onChange={handleIconChange}
          />
        </Form.Field>
        {icon.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {icon.error}
          </p>
        )}
        <Form.Field>
          <StyledLabel>Url amigável</StyledLabel>
          <Form.Input
            name="link"
            placeholder="Ex: voitto-pro (relacione com o nome do segmento que está sendo criado)"
            value={urlAmigavel.value}
            onChange={handleUrlAmigavelChange}
          />
        </Form.Field>
        {urlAmigavel.error && (
          <p
            style={{ marginBottom: "10px", fontSize: "12px", color: "#dd0000" }}
          >
            {urlAmigavel.error}
          </p>
        )}

        <StyledButton type="submit" onClick={submitForm}>
          <i class="plus icon"></i> Criar
        </StyledButton>
      </Form>
    </>
  );
};

export default CreateSegmentForm;
